import 'core-js/stable';
import 'regenerator-runtime/runtime';

import '../../bootstrap';
import $ from 'jquery';
import { device } from '../../_modules/device_decision';
import adjustScrollTopButton from '../../_modules/adjustScrollTopButton';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'jquery-colorbox';

export const exResetForm = resetForm;

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', () => {
  /**
   * スクロールイベント
   */
  adjustScrollTopButton();
  window.onload = function() {
    scrollEffect();
    window.addEventListener(
      'scroll',
      () => {
        // スクロールボタンの挙動
        adjustScrollTopButton();
        // スクロールによるDOMのエフェクト
        scrollEffect();

        // スクロール位置の保持
        localStorage.setItem('scroll_top', window.pageYOffset);
      },
      false
    );

    // 保持されたスクロール位置の適用
    if (!applyScroll) return;
    window.scrollTo(0, localStorage.getItem('scroll_top'));
  };

  //IEスムーススクロール解除
  if (
    navigator.userAgent.match(/MSIE 10/i) ||
    navigator.userAgent.match(/Trident\/7\./) ||
    navigator.userAgent.match(/Edge\/12\./)
  ) {
    $('body').on('mousewheel', function(event) {
      event.preventDefault();
      var wd = event.wheelDelta;
      var csp = window.pageYOffset;
      window.scrollTo(0, csp - wd);
    });
  }

  /**
   * ページ内スクロール
   */
  var loc = window.location;
  var url = loc.protocol + '//' + loc.hostname + loc.pathname;
  if (loc.search != '') {
    url += '?' + loc.search;
  }
  $(document).on('click', 'a[href*="#"]', function() {
    var speed = 300;
    var hash = $(this.hash);
    var paName = this.pathname;
    paName = paName.indexOf('/') == 0 ? paName : '/' + paName;
    var link = this.protocol + '//' + this.hostname + paName;
    if (this.search != '') {
      link += '?' + this.search;
    }
    if (url == link && hash) {
      const scrollElem = $(this).data('scroll') ? $($(this).data('scroll')) : $('html, body');
      var position = $(this).data('scroll')
        ? scrollElem.scrollTop() + hash.position().top
        : hash.offset().top;
      position -= device === 'pc' ? 100 : 100;
      scrollElem.animate({ scrollTop: position }, speed, 'swing');

      return false;
    }
  });

  window.addEventListener('load', function() {
    //ページ間アンカーリンク
    var headerHeight = $('.header').outerHeight();
    var urlHash = location.hash;
    if (urlHash) {
      $('body,html')
        .stop()
        .scrollTop(0);
      setTimeout(function() {
        var target = $(urlHash);
        var position = target.offset().top - 150;
        $('body,html')
          .stop()
          .animate({ scrollTop: position }, 500);
      }, 100);
    }
  });

  /**
   * 共通のプルダウン
   */
  $('.pulldown').on({
    mouseenter: function() {
      if (device == 'sp') {
        return;
      }
      $(this)
        .toggleClass('active')
        .find('ul')
        .stop()
        .slideToggle('fast');
    },
    mouseleave: function() {
      if (device == 'sp') {
        return;
      }
      $(this)
        .toggleClass('active')
        .find('ul')
        .stop()
        .slideToggle('fast');
    },
    click: function() {
      if (device == 'pc') {
        return;
      }
      $(this)
        .toggleClass('active')
        .find('ul')
        .stop()
        .slideToggle('fast');
    },
  });

  /**
   * ヘッダーナビゲーションのプルダウン
   */
  $('.pulldown-header').on({
    mouseenter: function() {
      if (device == 'sp') {
        return;
      }
      $(this)
        .toggleClass('active')
        .find('.nav-pc__pull-menu')
        .stop()
        .slideToggle('fast');
    },
    mouseleave: function() {
      if (device == 'sp') {
        return;
      }
      $(this)
        .toggleClass('active')
        .find('.nav-pc__pull-menu')
        .stop()
        .slideToggle('fast');
    },
    click: function() {
      if (device == 'pc') {
        return;
      }
      $(this)
        .toggleClass('active')
        .find('.nav-pc__pull-menu')
        .stop()
        .slideToggle('fast');
    },
  });

  /**
   * アコーディオンメニュー
   */
  const accordions = document.querySelectorAll('.accordion_close,.accordion_open');
  for (let accordion of accordions) {
    const enableDevice = accordion.dataset.device;
    if (enableDevice == undefined) continue;

    if (enableDevice != device) {
      accordion.nextElementSibling.removeAttribute('style');
      continue;
    }

    if (accordion.classList.contains('accordion_close')) {
      accordion.nextElementSibling.style.display = 'none';
    } else if (accordion.classList.contains('accordion_open')) {
      accordion.nextElementSibling.style.display = '';
    }
  }
  $(document).on('click', '.accordion_close,.accordion_open', function() {
    const enableDevice = $(this).data('device');
    if (enableDevice != undefined && enableDevice != device) {
      return;
    }
    $(this)
      .next('')
      .slideToggle('fast', function() {
        $(this).toggleClass('active');
        $(this).toggleClass('inactive');
        $(this)
          .prev()
          .toggleClass('accordion_close');
        $(this)
          .prev()
          .toggleClass('accordion_open');
      });
  });

  /**
   * アコーディオンメニュー（スマホ）
   */
  if (device == 'sp') {
    $('.sp-accordion--close').each(function() {
      $(this)
        .next()
        .hide();
    });
    $('.sp-accordion--open,.sp-accordion--close').click(function() {
      $(this)
        .next()
        .slideToggle('fast');
      $(this).toggleClass('sp-accordion--open');
      $(this).toggleClass('sp-accordion--close');
    });
  }

  /**
   * ページタイトル
   */
  $(window).on('load', function() {
    $('#js-page-title').addClass('show');
  });

  /**
   * 共通スライド
   */
  $('.topvisual-slider')
    .on('init', function(slick) {
      $(this).show();
    })
    .hide()
    .slick({
      dots: true,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1800,
      arrows: false,
      fade: true,
    });

  //link-list アンカーリンク用idの付与
  $('.js-link-list').each(function(i) {
    $(this).attr('id', 'link-list' + (i + 1));
  });

  //colorbox-inline
  $('.js-inline').on('click', function() {
    //アンカーリンク処理との競合を避けるためにdata属性で対象を指定
    var dataHref = $(this).attr('data-href');
    $.colorbox({
      href: dataHref,
      inline: true,
      maxWidth: '90%',
      maxHeight: '90%',
      opacity: 0.7,
    });
  });
});

/**
 * フォームのリセット
 * @param {formタグのname属性} formName
 */
function resetForm(formName) {
  var form = $('form[name="' + formName + '"]');
  form
    .find('input,textarea')
    .not('input[type="radio"],input[type="checkbox"],:hidden, :button, :submit,:reset')
    .val('');
  form
    .find('input[type="radio"], input[type="checkbox"],select option')
    .removeAttr('checked')
    .removeAttr('selected');
  form.find('p.txtRed').remove();
}

/**
 * スクロールによるDOMのエフェクト
 */
/*const scrollEffect = () => {
  const EFFECT_ELEMS = document.querySelectorAll('[data-effect]');
  if (EFFECT_ELEMS.length == 0) {
    return;
  }

  const VIEW_HEIGHT = (window.innerHeight ? window.innerHeight : document.documentElement.clientHeight) - 100;
  const ANIMATION_DELAY = 0.25;
  let animaionDelay = ANIMATION_DELAY;
  let prevTop = 0;

  for (let elem of EFFECT_ELEMS) {
    const className = elem.dataset.effect;
    const cList = elem.classList;
    const top = elem.getBoundingClientRect().top;
    if (cList.contains(className) || VIEW_HEIGHT < top) {
      continue;
    }
    if (top == prevTop) {
      animaionDelay += 0.1;
    } else {
      animaionDelay = ANIMATION_DELAY;
    }
    elem.style.animationDelay = animaionDelay + 's';
    cList.add(className);
    prevTop = top;
  }
};*/
